import * as React from "react";

export const ChevronRight: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#23252A",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    color={color}
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="m9.3 6.8 5.4 5.4-5.4 5.4"
    ></path>
  </svg>
);
